<div class="review">
  <ag-grid-angular
    style="width: 100%; height: 400px; padding-top: 20px"
    class="ag-theme-alpine-import"
    [gridOptions]="gridOptions"
    [pinnedTopRowData]="[headerRow]"
  >
  </ag-grid-angular>
  <div *ngIf="validated">
    <div class="review_note" *ngIf="invalidSkus.length">
      {{ errorRowCount }} SKU{{ errorRowCount > 1 ? "s are" : "is" }}
      invalid.
      <app-button
        [spin]="showRemoveLoader"
        (click)="removeInvalideSkus(true)"
        [buttonStyle]="'text'"
        [buttonSize]="'action'"
        >Remove and download invalid SKUs</app-button
      >
    </div>

    <div class="review_note" *ngIf="!invalidSkus.length">
      All SKUs are valid, click submit to execute.
    </div>
  </div>

</div>
